import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Nav from '../Nav/Nav';
import Footer from '../Footer/Footer';
import '../PrivacyPolicy/PrivacyPolicy.css';

const TermsOfUse = () => {
  return (
    <>
      <Helmet>
        <title>Terms of Use - Quickplanners</title>
        <meta name="description" content="Quickplanners Terms of Use - Learn about the rules and guidelines for using our platform." />
      </Helmet>
      
      <Nav />
      
      <div className="privacy-policy-container">
        <div className="privacy-content">
          <h1 className="privacy-title">Terms of Use — Quickplanners</h1>
          <p className="privacy-effective-date">Effective Date: 9th October 2025</p>
          
          <p className="privacy-intro">
            Welcome to Quickplanners. By accessing or using our platform, you agree to these Terms of Use. Please read them carefully.
          </p>

          <section className="privacy-section">
            <h2 className="privacy-section-title">1. Acceptance of Terms</h2>
            <p className="privacy-text">By creating an account, listing services, or booking vendors through Quickplanners, you agree to follow these terms and all applicable laws.</p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">2. Our Platform</h2>
            <p className="privacy-text">Quickplanners provides an online marketplace that connects event planners, individuals, and vendors (e.g., caterers, decorators, photographers).</p>
            <p className="privacy-text">We do not directly provide vendor services. All transactions and engagements are between users and vendors.</p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">3. Accounts</h2>
            <ul className="privacy-list">
              <li>You must be at least 18 years old to create an account.</li>
              <li>You are responsible for maintaining the confidentiality of your login details.</li>
              <li>Quickplanners may suspend or terminate any account suspected of fraud or misuse.</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">4. Vendor Registration & Fees</h2>
            <ul className="privacy-list">
              <li>Vendors may be required to pay a subscription fee (e.g., ₦5,000/month) to list and promote their services.</li>
              <li>Payments are non-refundable except as required by law.</li>
              <li>Quickplanners reserves the right to approve or reject vendor applications after due diligence.</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">5. Bookings & Transactions</h2>
            <ul className="privacy-list">
              <li>Customers are responsible for verifying vendor credibility before booking.</li>
              <li>Vendors must deliver services as agreed with customers.</li>
              <li>Quickplanners is not liable for disputes, losses, or damages arising from vendor or customer actions.</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">6. Prohibited Activities</h2>
            <p className="privacy-text">You agree not to:</p>
            <ul className="privacy-list">
              <li>Post false, misleading, or inappropriate content.</li>
              <li>Misuse the platform for illegal purposes.</li>
              <li>Attempt to hack, reverse-engineer, or disrupt platform functionality.</li>
              <li>Use another user's account without permission.</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">7. Intellectual Property</h2>
            <p className="privacy-text">All content, logos, and trademarks on Quickplanners belong to Quickplanners or its licensors. You may not copy or reuse them without written consent.</p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">8. Limitation of Liability</h2>
            <p className="privacy-text">Quickplanners is not liable for:</p>
            <ul className="privacy-list">
              <li>Any indirect, incidental, or consequential damages.</li>
              <li>Loss of data, profits, or service interruptions.</li>
            </ul>
            <p className="privacy-text">Use of our platform is at your own risk.</p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">9. Termination</h2>
            <p className="privacy-text">We may suspend or terminate your access at any time for violating these terms or for any reason we deem necessary to protect the platform.</p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">10. Changes to the Terms</h2>
            <p className="privacy-text">We may update these Terms of Use occasionally. Continued use after changes means you accept the updated version.</p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">11. Governing Law</h2>
            <p className="privacy-text">These Terms are governed by the laws of the Federal Republic of Nigeria.</p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-title">12. Contact</h2>
            <p className="privacy-text">For questions or complaints, contact:</p>
            <ul className="privacy-contact-list">
              <li> 
                <a href='mailto:support@quickplanners.com' className="privacy-contact-link" >
                support@quickplanners.com
                </a> 
                </li>
              <li>
                <Link to='/' className="privacy-contact-link" >
                  www.quickplanners.com
                </Link>
                </li>
            </ul>
          </section>

          <div className="privacy-back-link">
            <Link to="/" className="back-to-home">← Back to Home</Link>
          </div>
        </div>
      </div>
      
      <div className='content'>
        <Footer />
      </div>
      
    </>
  );
};

export default TermsOfUse;